import dictionary from './dictionary.json.js';
const config = {
    resource: 'next-energy-label',
    dictionary,
};
export default config;
//# sourceMappingURL=config.js.map